import omit from 'lodash/omit';
import { StreamElementType } from 'communication/types/StreamElementType';
import {
    StreamElementMessage,
    StreamMessageElement,
    StreamElement,
} from 'communication/types/StreamElement';
import { WidgetStreamMessagesState } from 'widgets/store/stream/WidgetStreamState';

export interface StreamMessage {
    message: string;
    date?: number;
}

export const toStreamMessage: (sme: StreamElementMessage) => StreamMessage = (
    sem
) => ({
    message: sem.t,
    date: sem.d,
});

export default function streamMessagesReducer(
    element: StreamMessageElement | StreamElement<StreamElementType.Clear>,
    nextState: WidgetStreamMessagesState
) {
    if (element._c === StreamElementType.Clear) {
        nextState.messages = [];
    } else if (element._c === StreamElementType.Msg) {
        if (element.m) {
            if (typeof element.m === 'string') {
                nextState.messages = [
                    ...nextState!.messages,
                    { message: element.m },
                ];
            } else if (Array.isArray(element.m) && element.m.length > 0) {
                nextState.messages = [
                    ...nextState!.messages,
                    ...element.m.map((m) => toStreamMessage(m)),
                ];
            }
        }
    }
}

export function omitStreamMessageTypeField<T extends StreamElement<unknown>>(
    element: T
): Pick<T, Exclude<keyof T, '_c'>> {
    return omit(element, ['_c']);
}
